import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import type { CasinoIcon } from '@swf/casino';
import { CasinoAllButton, CasinoSliderButtons } from '@swf/casino';
import type { SliderHandles, State as SliderState } from '@swf/components/Slider/Slider';
import { select } from '@swf/core/store';

import styles from './CasinoGameHeader.scss';
import CasinoHeaderTitle from './components/CasinoHeaderTitle/CasinoHeaderTitle';

interface Props {
  active?: number;
  icon?: CasinoIcon;
  moreLink?: string;
  title: string;
  subTitle?: string;
  sliderRef?: React.RefObject<SliderHandles>;
  sliderState?: SliderState;
}

const CasinoGameHeader: React.FC<Props> = ({
  moreLink,
  title,
  subTitle,
  icon,
  sliderRef,
  sliderState
}) => {
  const isMobile = useSelector(select.device.isMobile);
  const showScroll = !isMobile && sliderRef && icon && !['icnHeroWide'].includes(icon);

  return !(title || moreLink) && !showScroll ? null : (
    <header
      className={classNames(
        styles.header,
        !icon && styles.noIcon,
        !(title || moreLink) && styles.right
      )}
    >
      <CasinoHeaderTitle moreLink={moreLink} title={title} subTitle={subTitle} />
      {(moreLink || showScroll) && (
        <div className={styles.buttons}>
          {moreLink && <CasinoAllButton href={moreLink} />}
          {showScroll && sliderRef && sliderState && (
            <CasinoSliderButtons sliderRef={sliderRef} sliderState={sliderState} />
          )}
        </div>
      )}
    </header>
  );
};

export default CasinoGameHeader;
